import { useEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { useSelector } from "react-redux"
import ESMDetailsScreen from "../../screen/ESMDetailsScreen"
import { useScope } from "../SelectProjectCompanyContainer"
import { customToast } from "../../components/Toast"
import Send from "../../core/communication"
import { sort } from 'fast-sort'
import { pivot } from "../DynamicDashContainer"
import moment from 'moment';
import { getConceito } from "../../core/utils/getConceptEsm"
import { dividirTextoPorAcoes } from "../GenerateBeneficiaryEsmContainer"

// Função para calcular a média de um atributo específico
const calcularMedia = (array, atributo) => {
  const soma = array.reduce((total, objeto) => total + objeto.summary[atributo], 0);
  return soma / array.length;
};

// Função para calcular as médias para todos os atributos em todos os objetos
const calcularMedias = (array, field) => {
  // Encontre todos os atributos únicos
  const atributosUnicos = [...new Set(array.flatMap(objeto => Object.keys(objeto[field])))];

  // Crie um novo objeto para armazenar as médias
  const mediasObjeto = {};

  // Calcule a média para cada atributo
  atributosUnicos.forEach((atributo) => {
    const media = calcularMedia(array, atributo);
    mediasObjeto[atributo] = media;
  });

  return mediasObjeto;
};

const loadCommunityData = async (scopeId, scaleId, scopeType) => {
  const data = await Send.get(`/scale-producer-field/mean/${scopeId}/${scaleId}`, `scopeType=${scopeType}`)
  .catch(
    (error) => {
      customToast("Erro ao buscar dados da comunidade.", "error")
      console.log(error)
      return []
    },
  )

  return data
}

const loadCommunityDataActions = async (scopeId, scaleId, scopeType) => {
  const data = await Send.get(`/scale-action-producer/action/indicator/${scopeId}/${scaleId}`, `scopeType=${scopeType}`)
  .catch(
    (error) => {
      // customToast("Erro ao buscar dados da comunidade.", "error")
      console.log(error)
      return []
    },
  )

  return data
}

const loadProducerDataActions = async (scopeId, scaleProducerId, scaleId, scopeType) => {
  const data = await Send.get(`/scale-action-producer/action/producer/${scopeId}/${scaleProducerId}/${scaleId}`, `scopeType=${scopeType}`)
  .catch(
    (error) => {
      // customToast("Erro ao buscar dados para exportar pdf.", "error")
      console.log(error)
      return null;
    },
  );

  return data;
}

const ESMDetailsContainer = () => {
  const { scope, scopeType } = useScope()
  const location = useLocation()
  const { esm, esmData, esmId } = location?.state || {}

  const [communityData, setCommunityData] = useState({
    fields: [],
    summary: {
      Ambiental: 0,
      Econômico: 0,
      Social: 0,
    },
    details: { Geral: 0 },
  })
  
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [dataToExport, setDataToExport] = useState(null);
  const [dataValeToExport, setDataValeToExport] = useState(null);
  const [linkToDownloadPDC, setLinkToDownloadPDC] = useState(null);
  const params = useParams()
  const navigate = useNavigate()
  const users = useSelector((state) => state.app.users)
  const [filter, setFilter] = useState()
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [modalIsOpenGeneratePDF, setModalIsOpenGeneratePDF] = useState(false)
  const [scaleIndicator, setScaleIndicator] = useState("")
  const [categories, setCategories] = useState([]);
  const [heatmapData, setHeatmapData] = useState([])
  const [actionPlan, setActionPlan] = useState(null)
  const [loading, setLoading] = useState(false)

  const esmUser = users && users?.filter((item) => item.id === params.userId)[0]

  const communityDataDetails = [
    esm
      ? {
          ...esm,
          user: [{ id: Math.random(), name: "Esm", email: "Comunidade" }],
          details: {
            Conceito: getConceito(esm.details.Geral),
            ...esm.details,
          },
          generalScore: esm.details.Geral,
        }
      : {},
  ]

  const barometerData = esmData && communityDataDetails ? [...communityDataDetails, ...esmData] : esm ? [esm] : []

  const loadCategories = async (esmData) => {
    let categories = await Promise.all([...new Set(esmData.map(item => item.category))]);

    categories = await Promise.all(categories.map(category => {
      let fieldsByCategory = [];
      if (category !== 'GeneralMean') {
        fieldsByCategory = esmData.filter(item => item.category === category);
      } else {
        fieldsByCategory = esmData;
      }

      const mean = fieldsByCategory.reduce((acc, cur) => acc + Number(cur.value ?? 0), 0) / (fieldsByCategory.length || 1)

      return { category, mean };
    }));

    setCategories(categories);

    return categories;
  }

  const loadHeatmaps = async () => {
    let codes;


    if (esm) {
      try {
        codes = [JSON.parse(esm.codes).find(item => item.code === 'POCVALEBIO3')?.value]
      } catch (e) {
        console.log({ e })
      }
    } else if (esmData) {
      codes = esmData.map(item => JSON.parse(item.codes).find(item => item.code === 'POCVALEBIO3')?.value)
    }

    if (codes) {

      const allY = await Send.post('/ia/esm/solos-heatmap', {
        query: `Pergunta_codigo = 'SOLOSECN'`,
        select: "Resposta, Formulario"
      })

      const dataheatmap = await Send.post('/ia/esm/solos-heatmap', {
        query: `Pergunta_codigo = "POCVALEBIO3" and Resposta in (${codes.map(code => `"${code}"`)})`,
        select: "distinct Atendimento"
      }).then(atendimentos => {
        return Send.post('/ia/esm/solos-heatmap', {
          query: `Atendimento in (${atendimentos.map(item => `"${item.Atendimento}"`)})`,
          select: "*"
        })
      })

      const getForm = (id) => {
        switch (id) {
          case '27658b15-bebb-488c-bc46-410fbfd697da':
            return "Fósforo";
          case '3fe2b425-1fbc-40f8-b5f8-588a28eb015a':
            return "Enxofre";
          case 'a2b51f8e-e269-4275-87ba-052c720ac604':
            return "Nitrogênio";
          case 'f6910a2b-ffc5-489b-98e3-c5c97f6da5c2':
            return "Carbono";
          case 'ae08903b-3734-41f0-a08d-d288d66311fc':
            return "Bactérias";
          case 'e3f1d475-0257-4324-b9d4-6e2b8da5da47':
            return "Fungos";
        }
      }



      const items = [...new Set(dataheatmap.map(item => item.Formulario))].map(idForm => {
        const title = getForm(idForm);
        const data = dataheatmap.filter(item => item.Formulario === idForm)
        let yaxis = []

        if (["Bactérias", "Fungos"].includes(title)) {
          let items;
          if (title === 'Bactérias') {
            const bacterias = pivot(dataheatmap).filter(item => item.BACTERIAS && item.SOLOS_NOTA && parseInt(item.SOLOS_NOTA) != 0)
            yaxis = sort([...new Set(bacterias.map(item => item.BACTERIAS))]).asc(u => u)
            items = bacterias;
          } else if (title === 'Fungos') {
            const fungos = pivot(dataheatmap).filter(item => item.FUNGOS && item.SOLOS_NOTA && parseInt(item.SOLOS_NOTA) != 0)
            yaxis = sort([...new Set(fungos.map(item => item.FUNGOS))]).asc(u => u)
            items = fungos;
          }
          const xaxis = sort([...new Set(items.map(item => item.POCVALEBIO3))]).asc(u => u)

          return {
            title,
            data,
            yaxis,
            xaxis,
            zaxis: xaxis.map(id => {
              return yaxis.map(item => {
                const toValidate = items.find(a => a.POCVALEBIO3 === id && (a.FUNGOS === item || a.BACTERIAS === item))?.SOLOS_NOTA;

                if (toValidate == 5) {
                  return 50
                } else if (toValidate == 8) {
                  return 80
                } else if (toValidate == 10) {
                  return 100
                } else if (toValidate < 0) {
                  return -1;
                } else {
                  return 0;
                }
              })
            }),
          }
        } else {
          yaxis = sort([...new Set(allY.filter(item => item.Formulario === idForm).map(item => item.Resposta))]).asc(u => u)
          const xaxis = sort([...new Set(data.filter(item => item.Pergunta_codigo === 'POCVALEBIO3').map(item => item.Resposta))]).asc(u => u)

          return {
            title,
            data,
            yaxis,
            xaxis,
            zaxis: xaxis.map(id => {
              const atendimentos = [...new Set(data.filter(item => item.Pergunta_codigo === 'POCVALEBIO3' && item.Resposta === id).map(item => item.Atendimento))]
              const inItem = [...new Set(data.filter(item => atendimentos.includes(item.Atendimento) && item.Pergunta_codigo === 'SOLOSECN').map(item => item.Resposta))]
              return yaxis.map(item => inItem.includes(item) ? 100 : 0)
            })
          }
        }
      })

      setHeatmapData(items)
    }
  }

  useEffect(() => {
    if (esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc") {
      if (esmData) {
        loadHeatmaps()
        const summary = calcularMedias(esmData, "summary")
        

        // Use a função reduce para calcular a soma e a contagem
        const { soma, contagem } = esmData.reduce(
          (accumulator, objeto) => {
            const valorNumerico = parseFloat(objeto.details["Geral"]) || 0
            return {
              soma: accumulator.soma + valorNumerico,
              contagem: accumulator.contagem + 1,
            }
          },
          { soma: 0, contagem: 0 },
        )

        // Calcule a média
        const Geral = soma / contagem

        const allFields = esmData.map((item) => item.fields).flat()

        // Criar um objeto para armazenar a soma e a contagem dos valores por id
        const somaEContagemPorId = {}

        // Iterar sobre o array de objetos
        allFields.forEach((objeto) => {
          const { scaleIndicatorId, value, ...outrosAtributos } = objeto
          const valorNumerico = parseFloat(value) || 0

          // Se o id já estiver no objeto de soma, adicione o valor e aumente a contagem, senão, crie a entrada
          if (somaEContagemPorId[scaleIndicatorId]) {
            somaEContagemPorId[scaleIndicatorId].soma += valorNumerico
            somaEContagemPorId[scaleIndicatorId].contagem++
          } else {
            somaEContagemPorId[scaleIndicatorId] = { soma: valorNumerico, contagem: 1 }
          }
        })

        

        const fields = Object.keys(somaEContagemPorId).map((scaleIndicatorId) => {
          const data = allFields.find((item) => item.scaleIndicatorId === scaleIndicatorId)
          const media =
            somaEContagemPorId[scaleIndicatorId].soma /
            somaEContagemPorId[scaleIndicatorId].contagem

          return {
            ...data,
            value: media,
            concept: getConceito(media),
          }
        })

        // const fields = calcularMedias(esmData, 'fields');

        // Extrai os valores do atributo "value" como números
        // const valores = arrayDeObjetos.map(objeto => parseFloat(objeto.value) || 0);

        // Calcula a média dos valores
        // const media = valores.reduce((total, valor) => total + valor, 0) / valores.length;

        setCommunityData({ summary, fields, details: { Geral } })
        setDataValeToExport(fields)
        setDataToExport({
          id: "7ea1de77-706a-413f-a9da-cb6f82febcbc",
          month: moment().format("MMMM"),
          year: moment().format("YYYY"),
          summary,
          fields,
          details: { Geral },
        })
      }
    } else {
      if (!esm) {
        setCommunityData(formatCommunityEsmData(esmData))
        loadCommunityDataActions(scope?.id, esmId, scopeType).then((response) =>
          setDataToExport(response),
        )
      } else if (esm && !esmData) {
        loadProducerDataActions(scope?.id, esm.userId, esmId, scopeType).then((response) =>
          setDataToExport(response),
        )
      }
    }
  }, [esm, JSON.stringify(esmData)])

  useEffect(() => {
    if (esm || communityData) {
      loadCategories(esm?.fields || communityData.fields || []);
    }
  }, [esm, communityData])

  const goBack = () => {
    if (location.pathname.includes("community")) {
      navigate(location.pathname.split("/community")[0])
      setDataValeToExport(null)
      setDataToExport(null)
    }

    if (location.pathname.includes("producer")) {
      navigate(location.pathname.split("/producer")[0])
    }
  }

  const handleOpenGenerateEsm = () => {
    setModalIsOpenGeneratePDF(true)
  }

  const handleCloseGenerateEsm = () => {
    setModalIsOpenGeneratePDF(false)
    setActionPlan(null)
  }

  const fetchActionPlan = async () => {
    setLoading(true)

    const criterios = barometerData[0].fields?.map(({ title, concept, value, variables }) => ({
      title,
      concept,
      value,
      variables,
    }))

    try {
      const response = await fetch("https://api.openai.com/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer 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`,
        },
        body: JSON.stringify({
          model: "gpt-4o",
          messages: [
            {
              role: "user",
              content:
                "O sistema possui uma escala de 0 a 100 para identificar o índice de sustentabilidade, dessa forma, gere um plano de ação para aumentar os critérios encontrados: " +
                JSON.stringify({
                  criterios,
                }),
            },
          ],
          // max_tokens: 16000,
          temperature: 0.7,
        }),
      })

      const data = await response.json()

      setActionPlan(dividirTextoPorAcoes(data.choices[0].message?.content, 2200) || null)
    } catch (error) {
      console.error("Error fetching action plan:", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <ESMDetailsScreen
        {...{
          data: esmUser ? esm?.fields : communityData?.fields || [],
          filter,
          setFilter,
          esmData,
          goBack,
          esmUser,
          esm: esm || communityData,
          esmId: esmId || params?.esmId,
          userId: params?.userId,
          scaleIndicator,
          setScaleIndicator,
          setModalIsOpen,
          modalIsOpen,
          modalIsOpenGeneratePDF,
          setModalIsOpenGeneratePDF,
          isExportLoading,
          linkToDownloadPDC,
          dataToExport,
          dataValeToExport,
          categories,
          isCommunitySide: !esm,
          heatmapData,
          scope,
          barometerData,
          loadingActionPlan: loading,
          actionPlan,
          handleOpenGenerateEsm,
          handleCloseGenerateEsm
        }}
      />
    </>
  )
}

export default ESMDetailsContainer


const formatCommunityEsmData = (data) => {
  if (!Array.isArray(data) || data.length === 0) {
    return {
      details: { Geral: 0, Ecologico: 0, Humano: 0 },
      fields: [],
      summary: {
        Econômico: 0,
        Social: 0,
        Ambiental: 0,
        Agronômico: 0,
      },
    };
  }

  const initialDetails = { Geral: 0, Ecologico: 0, Humano: 0 };
  const initialSummary = {
    Econômico: 0,
    Social: 0,
    Ambiental: 0,
    Agronômico: 0,
  };

  const { details, summary } = data.reduce(
    (acc, current) => {
      const currentDetails = current?.details || {};
      const currentSummary = current?.summary || {};

      return {
        details: {
          Geral: acc.details.Geral + parseFloat(currentDetails.Geral || 0) || 0,
          Ecologico: acc.details.Ecologico + parseFloat(currentDetails.Ecologico || 0),
          Humano: acc.details.Humano + parseFloat(currentDetails.Humano || 0),
        },
        summary: {
          Econômico: acc.summary.Econômico + parseFloat(currentSummary.Econômico || 0),
          Social: acc.summary.Social + parseFloat(currentSummary.Social || 0),
          Ambiental: acc.summary.Ambiental + parseFloat(currentSummary.Ambiental || 0),
          Agronômico: acc.summary.Agronômico + parseFloat(currentSummary.Agronômico || 0),
        },
      };
    },
    { details: initialDetails, summary: initialSummary }
  );


  const average = (value) => parseFloat((value / data.length).toFixed(1)) || 0;

  return {
    details: {
      Geral: parseFloat(average(details.Geral)).toFixed(1),
      Ecologico: average(details.Ecologico),
      Humano: average(details.Humano),
    },
    fields: data[0]?.fields || [],
    summary: {
      Econômico: average(summary.Econômico),
      Social: average(summary.Social),
      Ambiental: average(summary.Ambiental),
      Agronômico: average(summary.Agronômico),
    },
  };
}
